export class WindowManager {
    static get window() {
        return window;
    }
    static getNamespace() {
        if (!WindowManager.window) {
            return {};
        }
        return WindowManager.window[WindowManager.namespace] || {};
    }
    static getByKey(key) {
        return WindowManager.getNamespace()[key];
    }
    static has(key) {
        return WindowManager.getByKey(key) !== undefined;
    }
    static get(key) {
        return WindowManager.getByKey(key);
    }
    static set(key, value) {
        if (!WindowManager.window) {
            return;
        }
        if (!WindowManager.window[WindowManager.namespace]) {
            WindowManager.window[WindowManager.namespace] = {};
        }
        WindowManager.window[WindowManager.namespace][key] = value;
    }
}
WindowManager.namespace = '__ksys-apps__';
//# sourceMappingURL=WindowManager.js.map